angular.
module("dx.webapp.masterTools.studentMerge").
controller("DxExamAnswersController", function ExamAnswersController(
	DX_QUESTION_TYPE,
	DX_WORD_GAP_MODE
) {
	"use strict";

	var self = this;
	self.DX_QUESTION_TYPE = DX_QUESTION_TYPE;
	self.DX_WORD_GAP_MODE = DX_WORD_GAP_MODE.STATIC;
});
